import { render, staticRenderFns } from "./geolocation.vue?vue&type=template&id=b50c2cd8&"
import script from "./geolocation.vue?vue&type=script&lang=js&"
export * from "./geolocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports